import { AppState } from "../app.state";

export const getLastFetchedDate = (state: AppState) => state.buchten.lastFetched;

export const getBuchtenStatus = (state: AppState) => state.buchten.loadStatus;

export const getShouldUpdateBuchtenTable = (state: AppState) => state.buchten.shouldUpdateBuchtenTable;
